import { render, staticRenderFns } from "./AdminFields.vue?vue&type=template&id=16c5a038&scoped=true"
import script from "./AdminFields.vue?vue&type=script&lang=js"
export * from "./AdminFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5a038",
  null
  
)

export default component.exports